import { MenuItem, Select, Typography, styled } from '@mui/material';
import { ReactNode, useState } from 'react';
import { useLocales } from 'src/locales';

export const RoleSelect = styled(Select)(({ theme }) => ({
  backgroundColor: theme.palette.background.default,
  '&:focus, &.Mui-focused': {
    backgroundColor: 'transparent',
  },
  '& div': {
    padding: 0,
  },
  '& .MuiSelect-select': {
    backgroundColor: theme.palette.background.default,
    '&:focus': {
      backgroundColor: 'transparent',
    },
    '& .MuiListItemText-secondary': {
      display: 'none',
    },
  },
  '&:hover': {
    backgroundColor: theme.palette.background.default,
  },
}));

export enum Roles {
  ADMIN = 'admin',
  VIEWER = 'viewer',
  MEMBER = 'member',
}

export enum ExtendedRoles {
  ADMIN = 'admin',
  EDIT_ALL = 'edit_all',
  EDIT_OWN = 'edit_own',
  EDIT_UNASSIGNED = 'edit_unassigned',
  VIEW_ALL = 'view_all',
  VIEW_OWN = 'view_own',
  VIEW_UNASSIGNED = 'view_unassigned',
}

export type RoleSelectProps = {
  participantId?: string;
  onRoleChange(data: {
    participantId?: string;
    role: Roles | ExtendedRoles;
  }): void;
  // children: ReactNode;
  options: {
    role: Roles | ExtendedRoles;
    label: ReactNode;
    description?: ReactNode;
  }[];
  selectedMemberRole?: Roles | ExtendedRoles;
  defaultRole?: Roles | ExtendedRoles;
  canEdit?: boolean;
};

export const WorkspaceShareMemberRoleSelectProps = ({
  participantId,
  onRoleChange,
  // children,
  options,
  selectedMemberRole,
  defaultRole = Roles.MEMBER,
  canEdit,
}: RoleSelectProps) => {
  const { translate } = useLocales();
  const [selectedValue, setSelectedValue] = useState<Roles | ExtendedRoles>(
    selectedMemberRole || defaultRole,
  );

  const handleRoleChange = ({ role }: { role: Roles }) => {
    setSelectedValue(role);
    onRoleChange({ participantId, role });
  };

  return canEdit ? (
    <RoleSelect
      size="small"
      name="role"
      variant="filled"
      defaultValue={defaultRole}
      value={selectedValue}
      onChange={(e) => handleRoleChange({ role: e.target.value as Roles })}
    >
      {options?.map((option) => (
        <MenuItem key={option.role} value={option.role}>
          {option.label}
        </MenuItem>
      ))}
    </RoleSelect>
  ) : (
    <Typography
      variant="body2"
      color={(theme) => theme.palette.text.secondary}
      style={{ textTransform: 'capitalize' }}
    >
      {selectedMemberRole
        ? translate(`shared.labels.${selectedMemberRole}`)
        : defaultRole}
    </Typography>
  );
};
